import React, { useCallback, useEffect, useRef } from 'react';
import ModalWrapper from 'src/components/common/modal/ModalWrapper';
import { blueButtonClass, inkoNpmOption } from 'src/components/common/common';
import { InspectTable_KSK2110_R01 } from './InspectTable_KSK2110_R01';
import { useKSK2110_R01Store } from './Store_KSK2110_R01';
import { AgGridReact } from 'ag-grid-react';
import { defaultKSK2110_R01LotSearchDto, KSK2110_R01InspectDto } from './Dto_KSK2110_R01';
import { useMouseContent } from 'src/utils/mouse/mouseContent';
import { InputForm } from 'src/components/common/form/input/InputForm';
import { validateString } from 'src/utils/string/stringUtil';
import { showWarning } from 'src/utils/toast/toastUtil';

interface Props {
	handleSearchLotList: (lotNoInput: string) => void;
}

export const LotModal_KSK2110_R01 = ({
	handleSearchLotList
}: Props) => {
	const { 
		lotModalVisible, setLotModalVisible,
		KSK2110_R01LotSearch, setKSK2110_R01LotSearch,
        KSK2110_R01DetailList, updateKSK2110_R01DetailList,
		initKSK2110_R01LotSearch,
	 } = useKSK2110_R01Store();

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {

		const name = e.target.name;
		let value = e.target.value;

		if(name === 'lotNo') {  } //lot번호는 무조건 영어로 - content에서 처리하기로함

		setKSK2110_R01LotSearch({ ...KSK2110_R01LotSearch, [name]: value });
	}

	const commitTransportQty = useCallback(() => {
		if(!validateString(KSK2110_R01LotSearch.lotNo)) {
			showWarning('Lot번호를 입력해주세요');
			return;
		}
		
        // lotNo가 일치하는 상세 항목 찾기
        const targetDetail = KSK2110_R01DetailList.find(
            (item) => item.lotNo === KSK2110_R01LotSearch.lotNo
        );

        if (targetDetail) {
            // 찾은 항목의 transportQty를 업데이트 (입력값이 문자열일 수 있으므로 Number로 변환)
            updateKSK2110_R01DetailList(targetDetail.valueIndex, {
                ...targetDetail,
                transportQty: Number(KSK2110_R01LotSearch.transportQty)
            });
            setLotModalVisible(true); // 화면 유지
			setKSK2110_R01LotSearch({ ...defaultKSK2110_R01LotSearchDto, });
        } else {
            showWarning('해당 LOT 번호에 일치하는 상세 항목을 찾을 수 없습니다.');
        }
		
	}, [KSK2110_R01LotSearch, KSK2110_R01DetailList, updateKSK2110_R01DetailList, lotModalVisible, setLotModalVisible]);

	const processSearchLotList = useCallback(() => {
		var Inko = require('inko');
		const inko = new Inko(inkoNpmOption);
		
		const currentLotNo = KSK2110_R01LotSearch.lotNoInput;
		if(validateString(currentLotNo)) {
			let newLotNo = inko.ko2en(currentLotNo).toUpperCase().trim();
			handleSearchLotList(newLotNo);
		}
	}, [KSK2110_R01LotSearch.lotNoInput, handleSearchLotList]);
	
	const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') { processSearchLotList(); }
	}, [KSK2110_R01LotSearch.lotNoInput, handleSearchLotList]);

	const handleClick = useCallback(() => {
		processSearchLotList();
	}, [processSearchLotList]);


    if (!lotModalVisible) return null;

    return (
        <ModalWrapper
            size={'qmd'}
            defaultWidth={400}
            overlay={true}
            onOverlayClick={() => setLotModalVisible(!lotModalVisible)}
            onEscKeyDown={() => {
                setLotModalVisible(!lotModalVisible);
            }}
        >
            <div className="w-full h-[10%] min-h-[10%] flex items-center px-[24px] bg-gray-100">
                <p className="font-bold">
                    자재출고 lot조회
                </p>
            </div>
			<div className="w-full h-[70%] min-h-[70%] flex flex-col px-[8px] py-[12px] gap-[4px]">
				{/* 바코드 스캔 필드(onBlur 사용) */}
				<div className="w-full flex flex-wrap items-center">
					<InputForm title="LOT No 입력" value={KSK2110_R01LotSearch.lotNoInput} editable={true} name="lotNoInput" onChange={handleChange} onBlur={(e) => handleChange(e)} onLoadFocus={true} onKeyDown={handleKeyDown}
						wrapperOption={{
							wrapperStyle: "w-[290px] min-w-[290px] mb-[4px]",
							titleStyle: "w-[150px] min-w-[150px] text-left",
							inputStyle: "w-[130px] min-w-[130px]",
						}}
					/>
					<button 
						// flex-shrink-0을 주어 버튼 크기가 찌그러지지 않도록 합니다.
						className="text-white bg-blue-dark items-center justify-center px-[8px] py-[2px] rounded-[4px] w-[65px] h-[32px] mb-[4px] flex-shrink-0" 
						onClick={handleClick}
					>
						조회
					</button>
				</div>
				<InputForm title="LOT No" value={KSK2110_R01LotSearch.lotNo} editable={false} name="lotNo"/>
				<InputForm title="품목코드" value={KSK2110_R01LotSearch.itemCd} editable={false} name="itemCd"/>
				<InputForm title="품목명" value={KSK2110_R01LotSearch.itemNm} editable={false} name="itemNm"/>
				<InputForm title="규격" value={KSK2110_R01LotSearch.itemSpec} editable={false} name="itemSpec"/>
				<InputForm title="품번" value={KSK2110_R01LotSearch.modelNo} editable={false} name="modelNo"/>
				<InputForm title="재고량" value={KSK2110_R01LotSearch.lotQty} editable={false} name="lotQty"/>
				<InputForm title="소요량" value={KSK2110_R01LotSearch.bomUsingQty} editable={false} name="bomUsingQty"/>
				<InputForm title="실출고량" value={KSK2110_R01LotSearch.transportQty} editable={true} name="transportQty" onChange={handleChange} />
			</div>
            <div className="w-full h-[20%] min-h-[20%] flex items-center px-[24px] gap-[8px]">
                <button
                    className={`${blueButtonClass} flex-shrink-0 text-white font-semibold px-4  rounded shadow h-[30px]`}
                    onClick={commitTransportQty}
                    disabled={false}
                >
                    등록
                </button>
				<button
                    className={`${blueButtonClass} flex-shrink-0 text-white font-semibold px-4  rounded shadow h-[30px]`}
                    onClick={() => initKSK2110_R01LotSearch()}
                    disabled={false}
                >
                    초기화
                </button>
                <button
                    className={`${blueButtonClass} flex-shrink-0 text-white font-semibold px-4  rounded shadow h-[30px]`}
                    onClick={() => setLotModalVisible(!lotModalVisible)}
                    disabled={false}
                >
                    취소
                </button>
				
            </div>
        </ModalWrapper>
    );
};

